import { ConfirmDialog } from '~/components/ConfirmDialog/ConfirmDialog';
import { GeneralInformation } from './components/general-information';
import { ContextMenu } from '~/components/ContextMenu/ContextMenu';
import { LifterListFilter } from './components/lifter-list-filter';
import { LifterListTable } from './components/lifter-list-table';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { useAuthentication } from '~/hooks/useAuthentication';
import { useDeleteClubMutation } from '../mutations';
import { insertOnCondition } from '~/utils/array';
import { useDialog } from '~/hooks/useDialog';
import { useParams } from '~/hooks/useParams';
import { Fragment } from 'react/jsx-runtime';
import { useNavigate } from 'react-router';
import { useClubQuery } from '../queries';
import { idParamSchema } from '~/schemas';
import { toast } from 'react-toastify';

export function Page() {
  const { id } = useParams(idParamSchema.parse);
  const { can } = useAuthentication();
  const { data } = useClubQuery(id);

  const deleteMutation = useDeleteClubMutation();
  const navigate = useNavigate();
  const dialog = useDialog();

  async function handleDelete() {
    await toast.promise(deleteMutation.mutateAsync(id), {
      success: 'Föreningen har tagits bort',
      pending: 'Tar bort förening...',
    });

    navigate('..');
  }

  if (!data) {
    return false;
  }

  return (
    <Fragment>
      <PageLayout.Header>
        <PageLayout.Heading text={data.name} />
        <PageLayout.Context
          items={[
            ...insertOnCondition(<ContextMenu.Item label="Redigera" to="edit" key="edit" />, can('edit-club', id)),
            ...insertOnCondition(
              <ContextMenu.Item label="Hantera rättigheter" to="admins" key="admins" />,
              can('list-club-admin', id)
            ),
            ...insertOnCondition(
              <ContextMenu.Item label="Ta bort" onClick={dialog.open} key="delete" danger />,
              can('delete-club', id)
            ),
          ]}
        />
      </PageLayout.Header>

      <PageLayout.Section>
        <GeneralInformation club={data} />
      </PageLayout.Section>

      <PageLayout.Section>
        <PageLayout.SubHeading>Lyftare</PageLayout.SubHeading>
        {can('list-club-admin', id) && <LifterListFilter />}
        <LifterListTable />
      </PageLayout.Section>

      <ConfirmDialog isLoading={deleteMutation.isPending} onConfirm={handleDelete} {...dialog} />
    </Fragment>
  );
}
